import { generalLink } from '@pkg/sanity-utils/linkQueries';
import groq from 'groq';

export const blockStepsSectionFields = groq`
  ...,
  slides[] {
    ...,
    content[] {
      ...,
      _type == "modularContentBlocks.inner.buttonGroup" => {
        buttons[] {
          ...,
          link {
            ...,
            ${generalLink}
          },
        },
      },
    },
  },
  buttons[] {
    ...,
    link {
      ...,
      ${generalLink}
      }
    }
`;
